import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import Header from '@/components/site/header'
import Footer from '@/components/site/footer'

export const Layout: FC<LayoutProps> = ({ children, transparentHeader = false, hideFooter = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#inhoud'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-sm focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:text-primary-foreground'
            >
                Direct naar de inhoud
            </a>

            <Header transparent={transparentHeader} />

            <main id='inhoud' className={cn('flex-1', !transparentHeader && 'pt-18')}>
                {children}
            </main>

            {!hideFooter && <Footer />}
        </div>
    )
}
